class Heartbeat {

    /** Heartbeat.js
     * Calls the Player Heartbeat API every X seconds, which is used for Continue Watching.
     */
    constructor(options) {
        console.log('Simplestream::Heartbeat::Constructor()');

        // Validate options
        if(!options.videoElement) {
            console.error('Simplestream::Heartbeat: Missing videoElement');
            return;
        } else if(!options.companyId) {
            console.error('Simplestream::Heartbeat: Missing companyId');
            return;
        } else if(!options.contentId) {
            console.error('Simplestream::Heartbeat: Missing contentId');
            return;
        } else if(!options.contentType) {
            console.error('Simplestream::Heartbeat: Missing contentType');
            return;
        } else if(!options.url) {
            console.error('Simplestream::Heartbeat: Missing url');
            return;
        }

        // Set options
        this.videoElement = options.videoElement;
        this.companyId = options.companyId;
        this.url = options.url;

        this.init();
    }

    /**
     * Initialise the pause ad container and events.
     */
    init() {
        this.videoElement.addEventListener('play', () => {
            console.log('Simplestream::Heartbeat::Event Play');

            if (typeof playerHeartbeat === 'undefined') {
										
				var userid = 'guest';
					
				$.get(this.url + 'start_session?user_id=' + userid + '&company_id=' + this.companyId + '&content_id=' + this.contentId + '&content_type=' + this.contentType + '&platform_id=website&play_head=' + Math.floor(this.videoElement.currentTime), function(data) {
					
					var obj = JSON.parse(data);
					session = obj.response.session_id;
					playerHeartbeat = true;
					
					setInterval(function() {
						$.get(this.url + 'update_session?session_id=' + session + '&company_id=' + this.companyId + '&play_head=' + Math.floor(this.videoElement.currentTime), function(data) {
		
						}); 
					}, 5000);
					
				});
			
			}
        });
    }
}

export default Heartbeat;